import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Card, CardTitle, CardBody, FormGroup, Label, Input, Button, CustomInput, Form, } from "reactstrap";
import Select from 'react-select';
import { Countries, States, genderOptions } from "../../../common/data/constants"
import Category from "pages/Setup/Category";
import "react-datepicker/dist/react-datepicker.css";
import { Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import {
  fetchCategories,
  fetchDepartments,
  fetchDesignations,
  fetchShiftGroups,
  fetchShifts,
  createEmployee,
  fetchEmployeeTabWiseInfo,fetchNextEmpNoRequest
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { FiSave } from "react-icons/fi";
import ava1 from "../../../assets/images/brands/user2.png";
import nv1 from "../../../assets/images/brands/b-nav-1.png";
import OrganizationalDetails from "./org_details";
import { useHistory } from "react-router-dom";
import CustomDatePicker from "common/CustomDatePicker";
import { success } from "toastr";
// import './style.css';

const salutationOptions = [
  { value: "1", label: "Mr." },
  { value: "2", label: "Ms." },
  { value: "3", label: "Mrs." },
  { value: "4", label: "Dr." },
];

const nameRegex = /^[A-Za-z.\s]+$/;              // Alphabets + dot + space
const placeRegex = /^[A-Za-z\s]+$/;              // Alphabets + space
const noAlphaSpecial = /^[0-9]+$/;               // Only digits
const mobileRegex = /^\+?[0-9]{10,15}$/;         // Optional + at front + digits
const mobileStrictRegex = /^\+?[0-9]+$/;         // Strict + only in front
const communityRegex = /^[A-Za-z\s]+$/;          // Alphabets + space only
const addressRegex = /^[A-Za-z0-9\s.,\-/#]+$/;
const EmployeePersonal = ({empID, dropdownData,isActive, onSuccess }) => {
  const orgFormikRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const [authDetails, setAuthDetails] = useState(null);
  const { blood_groups, country, state } = dropdownData;
  const [selectedCategory, setSelectedCategory] = useState(null);

  const {
    employeePersonalInfo = [],
    nextEmpNo,
    success,
    loading,
    error,
  } = useSelector((state) => ({
    employeePersonalInfo: empID == 0 ? [] : state.EmployeeDetailsReducer?.employeeTabData?.personal || [],
    nextEmpNo: state.EmployeeDetailsReducer?.nextEmpNo,
    loading: state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.shiftGroupReducer?.loading || state.shiftReducer?.loading || state.employeeReducer?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.shiftGroupReducer?.error || state.shiftReducer?.error || state.employeeReducer?.error || state.EmployeeDetailsReducer?.error,
    success: state.EmployeeDetailsReducer?.success
  }));

  useEffect(()=>{
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchShiftGroups(unitId));
    dispatch(fetchShifts(unitId));
  },[dispatch])


  const [photoPreview, setPhotoPreview] = useState(null);
  const [sameAsPresent, setSameAsPresent] = useState(false);
  const fileInputRef = useRef(null);

  const handleCheckboxChange = () => {
    setSameAsPresent(!sameAsPresent);
  };

  // useEffect(() => {
  //   if (error && error !== null && error !== undefined) {
  //     console.log("❌ Error Detected:", error);
  //   } else if (!loading) {
  //     // ✅ Navigate only if there's no error
  //     history.push("/manage-employee");
  //   }
  // }, [error, loading]);

  const formik = useFormik({
    initialValues: {
      empCode: '',
      salutation: '',
      fullName: '',
      dob: '',
      gender: '',
      bloodGroup: '',
      photoUpload: null,
      presentAddressLine1: '',
      presentAddressLine2: '',
      presentAddressLine3: '',
      presentPlace: '',
      presentcountry: '',
      presentstate: '',
      presentpostalCode: '',
      presentmobile: '',
      sameAsPermanent: false,
      permanentAddressLine1: "",
      permanentAddressLine2: "",
      permanentAddressLine3: "",
      permanentPlace: "",
      permanentcountry: "",
      permanentstate: "",
      permanentpostalCode: "",
      permanentmobile: "",
      emergency_contact_person: "",
      nationality: "",
      emergency_contact_no: "",
      community: "",
      pan_no: "",
      work_email: "",
      aadhar_no: "",
      uan_no: "",
      // physicallyChallenged: false,
      // timeSheet: false,
      // dataUpdateByEmployee: false,
      registrationNumber: '',
      registrationDate: '',
      renewalDate: '',
    },
    validationSchema: 
    // Yup.object({
    //   empCode: Yup.string().required('Employee Code is required'),
    //   fullName: Yup.string().required('Full Name is required'),
    //   salutation: Yup.object().required('Salutation is required'),
    //   dob: Yup.date()
    //     .required('Date of Birth is required')
    //     .test('min-age', 'Employee must be at least 18 years old', function (value) {
    //       if (!value) return false; // Ensure value is provided
    //       const today = new Date();
    //       const minAgeDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate()); 
    //       return value <= minAgeDate; // Ensures dob is at least 16 years before today
    //     }),
    //   gender: Yup.object().required('Gender is required'),
    //   registrationNumber: Yup.string().nullable(),
    //   registrationDate: Yup.date().nullable(),
    //   renewalDate: Yup.date()
    //     .nullable()
    //     .min(
    //       Yup.ref('registrationDate'),
    //       'Renewal Date cannot be before Registration Date'
    //     ),
    //   // bloodGroup: Yup.string().required('Blood Group is required'),
    //   photoUpload: Yup.mixed()
    //   // .required("A file is required") // ✅ Ensure a file is required
    //   .test(
    //     "fileValidation",
    //     "Photo is required and must be in JPG, JPEG, or PNG format (max 2MB).",
    //     (value, context) => {
    //       const { photoPreview } = context.parent;

    //       // ✅ Skip validation if a photo preview exists (i.e., existing image)
    //       if (photoPreview) return true;

    //       // ✅ Validate only if a new file is selected
    //       if (value && typeof value === "object") {
    //         console.log("File selected:", value);
    //         const isValidType = ["image/jpg", "image/jpeg", "image/png"].includes(value.type);
    //         const isValidSize = value.size && value.size <= 2 * 1024 * 1024; // Max 2MB

    //         return isValidType && isValidSize;
    //       }

    //       return false; // Trigger required error if no file is uploaded
    //     }
    //   ),     
    //   presentAddressLine1: Yup.string().required('Address Line 1 is required'),
    //   presentAddressLine2: Yup.string(),
    //   presentAddressLine3: Yup.string(),
    //   presentPlace: Yup.string().required('Place (City/Town) is required'),
    //   presentcountry: Yup.object().required('Country is required'),
    //   presentstate: Yup.object().required('State/Province is required'),
    //   presentpostalCode: Yup.string().matches(/^\d{6}$/, "Postal Code must be 6 digits").required('Postal Code is required'),
    //   presentmobile: Yup.string().matches(/^\d{10}$/, "Mobile must be 10 digits").required('Mobile is required'),
    //   // sameAsPermanent: Yup.boolean(),
    //   // permanentAddressLine1: Yup.string().required("Address Line 1 is required"),
    //   // permanentPlace: Yup.string().required("Place (City/Town) is required"),
    //   // permanentcountry: Yup.object().required("Country is required"),
    //   // permanentstate: Yup.object().required("State/Province is required"),
    //   permanentpostalCode: Yup.string()
    //     .matches(/^\d{6}$/, "Postal Code must be 6 digits"),
    //   permanentmobile: Yup.string()
    //     .matches(/^\d{10}$/, "Mobile must be 10 digits"),
    //   // emergency_contact_person: Yup.string().required("Required"),
    //   // nationality: Yup.string().required("Required"),
    //   // emergency_contact_no: Yup.string()
    //   //   .matches(/^[0-9]+$/, "Must be a valid number")
    //   //   .min(10, "Must be at least 10 digits")
    //   //   .required("Required"),
    //   pan_no: Yup.string()
    //     .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format")
    //     .required("PAN Number required"),
    //   work_email: Yup.string().email("Invalid email").required("Work Email is required"),
    //   aadhar_no: Yup.string()
    //     .matches(/^[0-9]{12}$/, "Must be a valid 12-digit Aadhar number")
    //     .required("Aadhaar Number is required"),
    //   uan_no: Yup.string().matches(/^[0-9]{12}$/, "Must be a valid UAN number"),
    // }),
    Yup.object({
      empCode: Yup.string()
        .max(10, "Max length is 10")
        .required("Employee Code is required"),

      fullName: Yup.string()
        .matches(nameRegex, "Only alphabets allowed (dot allowed)")
        .max(50, "Max length is 50")
        .required("Full Name is required"),

      salutation: Yup.object().required("Salutation is required"),

      dob: Yup.date()
        .required("Date of Birth is required")
        .test("min-age", "Employee must be at least 18 years old", function (value) {
          if (!value) return false;
          const today = new Date();
          const minAgeDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
          return value <= minAgeDate;
        }),

      gender: Yup.object().required("Gender is required"),

      registrationNumber: Yup.string().nullable(),
      registrationDate: Yup.date().nullable(),

      renewalDate: Yup.date()
        .nullable()
        .min(Yup.ref("registrationDate"), "Renewal Date cannot be before Registration Date"),

      // photoUpload: Yup.mixed().test(
      //   "fileValidation",
      //   "Photo must be JPG/JPEG/PNG format (max 2MB).",
      //   (value, context) => {
      //     const { photoPreview } = context.parent;
      //     if (photoPreview) return true;

      //     if (value && typeof value === "object") {
      //       const isValidType = ["image/jpg", "image/jpeg", "image/png"].includes(value.type);
      //       const isValidSize = value.size && value.size <= 2 * 1024 * 1024;
      //       return isValidType && isValidSize;
      //     }
      photoUpload: Yup.mixed()
        .nullable()
        .test(
          "fileType",
          "Only JPG, JPEG, and PNG formats are allowed.",
          (value) => {
            if (!value) return true;
            return ["image/jpg", "image/jpeg", "image/png"].includes(value.type);
          }
        )
        .test(
          "fileSize",
          "File size must not exceed 2MB.",
          (value) => {
            if (!value) return true;
            return value.size <= 2 * 1024 * 1024;
          return false;
        }
      ),

      presentAddressLine1: Yup.string().required("Address Line 1 is required"),
      presentAddressLine2: Yup.string().nullable(),
      presentAddressLine3: Yup.string().nullable(),
      presentPlace: Yup.string().required("Place (City/Town) is required"),
      presentcountry: Yup.object().required("Country is required"),
      presentstate: Yup.object().required("State/Province is required"),

      presentpostalCode: Yup.string().max(6)
        .matches(/^[0-9]{6}$/, "Postal Code must be 6 digits")
        .required("Postal Code is required"),

      presentmobile: Yup.string().max(13)
        .matches(/^\+?[0-9]{10}$/, "Mobile must be 10 digits, + only at start")
        .required("Mobile is required"),

      permanentpostalCode: Yup.string()
        .nullable()
        .matches(/^[0-9]{6}$/, "Postal Code must be 6 digits"),

      permanentmobile: Yup.string()
        .nullable()
        .matches(/^\+?[0-9]{10}$/, "Mobile must be 10 digits, + only at start"),

      emergency_contact_person: Yup.string()
        .matches(nameRegex, "Only alphabets allowed (dot allowed)")
        .max(50, "Max length is 50")
        .nullable(),

      nationality: Yup.string()
        .matches(placeRegex, "Only alphabets allowed")
        .max(20, "Max length is 20")
        .nullable(),

      emergency_contact_no: Yup.string()
        .matches(/^\+?[0-9]{10,15}$/, "Only numbers allowed, + only at front")
        .max(15, "Max length is 15")
        .nullable(),

      community: Yup.string()
        .matches(communityRegex, "Only alphabets allowed (space allowed)")
        .max(50, "Max length is 50")
        .nullable(),

      pan_no: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format")
        .required("PAN Number required"),

      work_email: Yup.string()
        .email("Invalid email format")
        .max(100, "Work Email must not exceed 100 characters")
        .required("Work Email is required"),

      aadhar_no: Yup.string().max(12)
        .matches(/^\d{12}$/, "Aadhaar must be 12 digits")
        .required("Aadhaar Number is required"),

      uan_no: Yup.string().max(12)
        .matches(/^\d{12}$/, "UAN must be 12 digits")
        .required("UAN Number is required"),
    }),
    onSubmit: async (values) => {

      if (empID == 0) {
        // If emp_id is 0, also validate and submit org details
        if (orgFormikRef.current) {
          await orgFormikRef.current.setTouched(
            Object.keys(orgFormikRef.current.values).reduce((acc, key) => {
              acc[key] = true; // Mark all fields as touched
              return acc;
            }, {}),
            true
          );
      
          await orgFormikRef.current.validateForm(); // Trigger validation
      
          if (Object.keys(orgFormikRef.current.errors).length > 0) {
            console.log("Fix errors in Organizational Details!");
            return;
          }
        }
      }
      
      const payload = {
        emp: [
          {
            emp_id: empID, // This might need dynamic mapping
            emp_no: values.empCode || "",
            salutation: values.salutation?.value || "0",
            salutation_name: values.salutation?.label || "",
            first_name: values.fullName || "",
            dob: values.dob || "",
            gender_id: values.gender?.value || "0",
            gender_name: values.gender?.label || "",
            passport_no: "", // Add if available
        
            // Handling blood group correctly
            blood_group_id: values.bloodGroup?.value || "0",
            blood_group: values.bloodGroup?.label || "",

            // ✅ Registration Details
            registration_no: values.registrationNumber || "",
            reg_date: values.registrationDate ? values.registrationDate : "",
            renewal_date: values.renewalDate ? values.renewalDate : "",
        
            // Present Address Mapping
            present_address_lane1: values.presentAddressLine1 || "",
            present_address_lane2: values.presentAddressLine2 || "",
            present_address_lane3: values.presentAddressLine3 || "",
            present_per_place: values.presentPlace || "",
            present_state_id: values.presentstate?.value || "0",
            present_state: values.presentstate?.label || "",
            present_country_id: values.presentcountry?.value || "0",
            present_country: values.presentcountry?.label || "",
            present_postalcode: values.presentpostalCode || "",
            pre_mobile: values.presentmobile || "",
        
            // Permanent Address Mapping
            address_lane1: values.permanentAddressLine1,
            address_lane2: values.permanentAddressLine2,
            address_lane3: values.permanentAddressLine3,
            per_place: values.permanentPlace || "",
            per_mobile: values.permanentmobile || "",
            state_id: values.permanentstate?.value || "0",
            per_state: values.permanentstate?.label || "",
            country_id: values.permanentcountry?.value || "0",
            per_country: values.permanentcountry?.label || "",
            per_postalcode: values.permanentpostalCode || "",
        
            // Emergency Contact
            emergency_contact_no: values.emergency_contact_no || "",
            emergency_contact_person: values.emergency_contact_person || "",
        
            // Other Fields
            pan_no: values.pan_no || "",
            adhar_no: values.aadhar_no || "",
            // physically_challenged: values.physicallyChallenged ? "1" : "0",
            nationality: values.nationality || "",
            community: values.community || "",
            work_email: values.work_email || "",
            uan_no: values.uan_no || "",
            // timesheet: values.timeSheet ? "1" : "0",
            // data_update_emp: values.dataUpdateByEmployee ? "1" : "0",
            create_by: authDetails.user_id || ""
          }
        ]
      };
      const formData = new FormData();
      // formData.append("lst_employee_personnel", JSON.stringify(payload));
      formData.append("create_by", authDetails.user_id);
      formData.append("profile_image", values.photoUpload);
      // dispatch(createEmployee(formData,'personal'));


      // console.log('payload  > ',payload)

      // return;
      if (empID == 0) {
        const orgDetails = empID == 0 ? orgFormikRef.current.values : {};

        const newpayload = {
          emp: [
            {
              cat_id: values.category?.value || orgDetails.category?.value || "", 
              category: values.category?.label || orgDetails.category?.label || "",
              dept_id: values.department?.value || orgDetails.department?.value || "",
              department: values.department?.label || orgDetails.department?.label || "",
              desig_id: values.designation?.value || orgDetails.designation?.value || "",
              desination: values.designation?.label || orgDetails.designation?.label || "",
              doj: values.doj ? `${values.doj} 00:00:00` : orgDetails.doj ? `${orgDetails.doj} 00:00:00` : "",
              audit_doj: values.audit ? `${values.audit} 00:00:00` : orgDetails.audit ? `${orgDetails.audit} 00:00:00` : "",
              emp_type: values.employeeType?.value || orgDetails.employeeType?.value || "",
              emp_nature: values.employeeNature?.value || orgDetails.employeeNature?.value || "",
              reporting_id: values.reportingTo?.value || orgDetails.reportingTo?.value || "",
              reporting: values.reportingTo?.label || orgDetails.reportingTo?.label || "",
              salary_through: values.salaryThrough?.value || orgDetails.salaryThrough?.value || "0",
              wage_type: values.salaryType?.value || orgDetails.salaryType?.value || "0",
              att_not_required: values.attendanceNotRequired ? "1" : orgDetails.attendanceNotRequired ? "1" : "0",
              auto_approval: values.markerAutoApproval ? "1" : orgDetails.markerAutoApproval ? "1" : "0",
              eliminate_app_workflow: values.eliminateApprovalWorkflow ? "1" : orgDetails.eliminateApprovalWorkflow ? "1" : "0",
              pf_not_eligible: values.pfNotEligible ? "1" : orgDetails.pfNotEligible ? "1" : "0",
              esi_not_eligible: values.esiNotEligible ? "1" : orgDetails.esiNotEligible ? "1" : "0",
              hourly_wages: values.salaryProcessedByHourlyWages ? "1" : orgDetails.salaryProcessedByHourlyWages ? "1" : "0",
              shift_change: values.shiftChange?.value || orgDetails.shiftChange?.value || "",
              data_update_emp: values.dataUpdateByEmployee ? "1" : orgDetails.dataUpdateByEmployee ? "1" : "0",
              is_extra_eli: values.weekoffEligibility ? "1" : orgDetails.weekoffEligibility ? "1" : "0",
              is_extra_duty: values.extraDutyEligibility ? "1" : orgDetails.extraDutyEligibility ? "1" : "0",
              is_shift_late: values.shiftLateEligibility ? "1" : orgDetails.shiftLateEligibility ? "1" : "0",
              is_permission: values.permissionEligibility ? "1" : orgDetails.permissionEligibility ? "1" : "0",
              is_incentive: values.incentiveEligibility ? "1" : orgDetails.incentiveEligibility ? "1" : "0",
              punch_based_shift: values.punchBasedShiftUpdate ? "1" : orgDetails.punchBasedShiftUpdate ? "1" : "0",
              is_cl: values.earnedLeaveEligibility ? "1" : orgDetails.earnedLeaveEligibility ? "1" : "0",
              is_el: values.earnedLeaveEligibility ? "1" : orgDetails.earnedLeaveEligibility ? "1" : "0",
              is_mob_usr: values.mobileUser ? "1" : orgDetails.mobileUser ? "1" : "0",
              create_by: authDetails.user_id,
              shift_grp_id: values.shiftGroup?.value || orgDetails.shiftGroup?.value || "",
              shift_id: values.shift?.value || orgDetails.shift?.value || "",
              week_off: values.weekOff?.map(item => item.value).join(",") || orgDetails.weekOff?.map(item => item.value).join(",") || "",
              unit_id: authDetails?.unit_id
            }
          ]
        };


        const mergedEmp = {
          ...payload.emp[0],  // Extract first employee object from payload
          ...newpayload.emp[0] // Extract first employee object from newpayload
        };
        
        // Construct final payload
        const updatedPayload = {
          emp: [mergedEmp] // Ensure emp remains an array with the merged object
        };

        formData.append("lst_employee_personnel", JSON.stringify(updatedPayload));
        dispatch(createEmployee(formData, "personal_org",history));
      } else {
        formData.append("lst_employee_personnel", JSON.stringify(payload));
        // For existing employees, just submit the personal form
        dispatch(createEmployee(formData, "personal"));
      }

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        fileInputRef.current.label = ""; // ✅ Ensure file input resets safely
      }
      // setPhotoPreview(null)
      // formik.setFieldValue("photoUpload", null);
      // formik.resetForm()      
    }
  });

  const [inputKey, setInputKey] = useState(Date.now());
  useEffect(() => {
    if (success) {
      formik.resetForm();
      setPhotoPreview(null);
      setInputKey(Date.now()); 
      if(onSuccess){
        onSuccess();
      }
    }
  }, [success,onSuccess]);

  useEffect(() => {
    if (formik.values.sameAsPermanent) {
      formik.setValues({
        ...formik.values,
        permanentAddressLine1: formik.values.presentAddressLine1,
        permanentAddressLine2: formik.values.presentAddressLine2,
        permanentAddressLine3: formik.values.presentAddressLine3,
        permanentPlace: formik.values.presentPlace,
        permanentcountry: formik.values.presentcountry,
        permanentstate: formik.values.presentstate,
        permanentpostalCode: formik.values.presentpostalCode,
        permanentmobile: formik.values.presentmobile,
      });
    }
  }, [
    formik.values.sameAsPermanent,
    formik.values.presentAddressLine1,
    formik.values.presentAddressLine2,
    formik.values.presentAddressLine3,
    formik.values.presentPlace,
    formik.values.presentcountry,
    formik.values.presentstate,
    formik.values.presentpostalCode,
    formik.values.presentmobile
  ]);

  const handlePhotoUpload = (event, setPreview) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (employeePersonalInfo && employeePersonalInfo.length > 0) {
      const employeeData = employeePersonalInfo[0];
      const filePath = employeeData?.profile_image_path
                      ? `${process.env.REACT_APP_IMAGE_BASE_URL}${employeeData.profile_image_path}`
                      : null;
      formik.setValues({
        empCode: employeeData.emp_no,
        salutation: { value: employeeData.salutation, label: employeeData.salutation_name }, 
        fullName: `${employeeData.first_name} ${employeeData.LastName || ''}`.trim(),
        dob: employeeData.dob ? employeeData.dob.split("T")[0] : "", // Formatting Date
        gender: { value: employeeData.gender_id, label: employeeData.gender_name },
        bloodGroup: { value: employeeData.blood_group_id, label: employeeData.blood_group },
        photoUpload: null, 
        presentAddressLine1: employeeData.present_address_lane1,
        presentAddressLine2: employeeData.present_address_lane2 || "",
        presentAddressLine3: employeeData.present_address_lane3 || "",
        presentPlace: employeeData.present_per_place || "",
        presentcountry: { value: employeeData.present_country_id, label: employeeData.present_country },
        presentstate: { value: employeeData.present_state_id, label: employeeData.present_per_state },
        presentpostalCode: employeeData.present_postalcode ? employeeData.present_postalcode.toString() : "",
        presentmobile: employeeData.pre_mobile ? employeeData.pre_mobile.toString() : "",
        sameAsPermanent: false, // To be handled in UI
        permanentAddressLine1: employeeData.address_lane1,
        permanentAddressLine2: employeeData.address_lane2 || "",
        permanentAddressLine3: employeeData.address_lane3 || "",
        permanentPlace: employeeData.per_place || "",
        permanentcountry: { value: employeeData.country_id, label: employeeData.per_country },
        permanentstate: { value: employeeData.state_id, label: employeeData.per_state },
        permanentpostalCode: employeeData.per_postalcode ? employeeData.per_postalcode.toString() : "",
        permanentmobile: employeeData.per_mobile ? employeeData.per_mobile.toString() : "",
        emergency_contact_person: employeeData.emergency_contact_person || "",
        nationality: employeeData.nationality,
        emergency_contact_no: employeeData.emergency_contact_no ? employeeData.emergency_contact_no.toString() : "",
        community: employeeData.community, 
        pan_no: employeeData.pan_no || "",
        work_email: employeeData.work_email || "",
        aadhar_no: employeeData.adhar_no, 
        uan_no: employeeData.uan_no, 
        // physicallyChallenged: Boolean(employeeData.physically_challenged), 
        // timeSheet: Boolean(employeeData.timesheet),
        // dataUpdateByEmployee: Boolean(employeeData.data_update_emp), 

        registrationNumber: employeeData.registration_no || "",
        registrationDate: employeeData.reg_date ? employeeData.reg_date.split("T")[0] : "",
        renewalDate: employeeData.renewal_date ? employeeData.renewal_date.split("T")[0] : "",
      });
      setPhotoPreview(filePath)
      formik.setFieldValue("photoPreview", filePath);
    }
  }, [employeePersonalInfo]);

  useEffect(() => {
    if (dropdownData && Object.keys(dropdownData).length > 0 && isActive) {
          const timeoutId = setTimeout(() => {
              dispatch(fetchEmployeeTabWiseInfo(empID, 'personal'));
          }, 500);

          return () => clearTimeout(timeoutId);
      }
  }, [dispatch, dropdownData, isActive]);

   useEffect(() => {
    if (authDetails?.unit_id) {
      dispatch(
        fetchNextEmpNoRequest(
          authDetails.unit_id,
          selectedCategory?.value || 0   // initial load
        )
      );
    }
  }, [authDetails, dispatch]);

  useEffect(() => {
    if (authDetails?.unit_id && selectedCategory?.value) {
      dispatch(fetchNextEmpNoRequest(authDetails.unit_id, selectedCategory.value)
      );
    }
  }, [selectedCategory, authDetails, dispatch]);


  // Populate EmpNo when API response comes
  useEffect(() => {
    if (nextEmpNo) {
      formik.setFieldValue('empCode', nextEmpNo);
    }

  }, [nextEmpNo]);

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  return (
    <div onSubmit={formik.handleSubmit}>
      <Card>
        <div className="card-main-title">
          <h6 className="title">
            <img src={nv1} className="img-fluid w-auto h-auto" alt="img" />
            Personal Information
          </h6>
        </div>
        <CardBody className="per-info">
          <Row>
            <Col className="col-12">
              <div className="family-details d-flex gap-20 align-items-center image-upload">
                <div className="photo-div">
                  <img 
                    src={photoPreview ? photoPreview : ava1} 
                    alt="Profile" 
                  />
                </div>

                {/* File Upload Field */}
                <div>
                  <div className="upload-personal d-flex gap-2">
                    <FormGroup>
                      <Input
                        key={inputKey}
                        id="photoUpload"
                        name="photoUpload"
                        type="file"
                        accept="image/jpeg, image/png"
                        ref={fileInputRef}
                        onChange={(e) => {
                          const file = e.currentTarget.files[0];
                          if (file) {
                            const allowedTypes = ["image/jpg", "image/jpeg", "image/png"];
                            const maxSize = 2 * 1024 * 1024; // 2MB

                            if (!allowedTypes.includes(file.type)) {
                              formik.setFieldError("photoUpload", "Only JPG, JPEG, and PNG formats are allowed.");
                              return;
                            }
                            if (file.size > maxSize) {
                              formik.setFieldError("photoUpload", "File size must not exceed 2MB.");
                              return;
                            }

                            const reader = new FileReader();
                            reader.onloadend = () => {
                              setPhotoPreview(reader.result);
                              formik.setFieldValue("photoPreview", reader.result);
                            };
                            reader.readAsDataURL(file);
                            formik.setFieldValue("photoUpload", file);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.photoUpload && !!formik.errors.photoUpload}
                      />
                      {formik.touched.photoUpload && formik.errors.photoUpload && (
                        <div className="text-danger">{formik.errors.photoUpload}</div>
                      )}
                    </FormGroup>
                    <Button
                      type="reset"
                      className="btn btn-light account-image-reset mb-3"
                      onClick={() => {
                        formik.setFieldValue("photoUpload", null);
                        setPhotoPreview(null);
                        fileInputRef.current.value = ""; // Clear input field
                      }}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              </div>
            </Col>


            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="empCode">Emp ID <span className="text-danger">*</span></Label>
                <Input
                  id="empCode"
                  name="empCode"
                  type="text"
                  maxLength={10}
                  value={formik.values.empCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.empCode && !!formik.errors.empCode}
                  disabled={true}
                />
                {formik.touched.empCode && formik.errors.empCode && (
                  <div className="text-danger">{formik.errors.empCode}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="salutation">Salutation <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="salutation"
                  name="salutation"
                  // options={salutationOptions.map((sal) => ({
                  //   value: sal.value,
                  //   label: sal.label,
                  // }))}
                  // value={salutationOptions.find((option) => option.value === formik.values.salutation) || null}
                  // onChange={(selectedOption) => formik.setFieldValue("salutation", selectedOption)} // Store only the value
                  options={salutationOptions}
                  value={formik.values.salutation || null} // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("salutation", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.salutation && formik.errors.salutation ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.salutation && formik.errors.salutation && (
                  <div className="text-danger">{formik.errors.salutation}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="fullName">Full Name <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  id="fullName"
                  name="fullName"
                  maxLength={50}
                  value={formik.values.fullName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.fullName && !!formik.errors.fullName}
                />
                {formik.touched.fullName && formik.errors.fullName && (
                  <div className="text-danger">{formik.errors.fullName}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="dob">Date of Birth <span className="text-danger">*</span></Label>
                {/* <Input
                  type="date"
                  id="dob"
                  name="dob"
                  value={formik.values.dob || null}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.dob && !!formik.errors.dob}
                /> */}
                 <CustomDatePicker
                  value={formik.values.dob}
                  onChange={(date) => formik.setFieldValue("dob", date)}
                  onBlur={() => formik.setFieldTouched("dob", true)}
                  disableFuture={true}
                />
                {formik.touched.dob && formik.errors.dob && (
                  <div className="text-danger">{formik.errors.dob}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="gender">Gender <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="gender"
                  name="gender"
                  // options={genderOptions.map((sal) => ({
                  //   value: sal.value,
                  //   label: sal.label,
                  // }))}
                  // // value={genderOptions.find((option) => option.value === formik.values.gender) || null}
                  // value={formik.values.gender || null}
                  // onChange={(selectedOption) => formik.setFieldValue("gender", selectedOption)} // Store only the value
                  options={genderOptions}
                  value={formik.values.gender || null} // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("gender", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.gender && formik.errors.gender ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />

                {formik.touched.gender && formik.errors.gender && (
                  <div className="text-danger">{formik.errors.gender}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="bloodGroup">Blood Group</Label>
                <Select
                  styles={SelectcustomStyles}
                  id="bloodGroup"
                  name="bloodGroup"
                  options={(blood_groups || []).map(bg => ({ value: bg.bloodgroup_id.toString(), label: bg.blood_group }))}
                  value={formik.values.bloodGroup || null} // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("bloodGroup", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.bloodGroup && formik.errors.bloodGroup ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.bloodGroup && formik.errors.bloodGroup && (
                  <div className="text-danger">{formik.errors.bloodGroup}</div>
                )}
              </FormGroup>
            </Col>

            {/* Registration Number */}
            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="registrationNumber">Registration Number</Label>
                <Input
                  type="text"
                  id="registrationNumber"
                  name="registrationNumber"
                  value={formik.values.registrationNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.registrationNumber && !!formik.errors.registrationNumber}
                />
                {formik.touched.registrationNumber && formik.errors.registrationNumber && (
                  <div className="text-danger">{formik.errors.registrationNumber}</div>
                )}
              </FormGroup>
            </Col>

            {/* Registration Date */}
            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="registrationDate">Registration Date</Label>
                <CustomDatePicker
                  name="registrationDate"
                  value={formik.values.registrationDate}
                  onChange={(date) => formik.setFieldValue("registrationDate", date)}
                  onBlur={() => formik.setFieldTouched("registrationDate", true)}
                  disableFuture={true}
                />
                {formik.touched.registrationDate && formik.errors.registrationDate && (
                  <div className="text-danger">{formik.errors.registrationDate}</div>
                )}
              </FormGroup>
            </Col>

            {/* Renewal Date */}
            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="renewalDate">Renewal Date</Label>
                <CustomDatePicker
                  name="renewalDate"
                  value={formik.values.renewalDate}
                  onChange={(date) => formik.setFieldValue("renewalDate", date)}
                  onBlur={() => formik.setFieldTouched("renewalDate", true)}
                  minDate={formik.values.registrationDate || null}
                />
                {formik.touched.renewalDate && formik.errors.renewalDate && (
                  <div className="text-danger">{formik.errors.renewalDate}</div>
                )}
              </FormGroup>
            </Col>

            <Col className="col-12 mt-2">
              <h6 className="mb-3">Present Address</h6>
              <Row>
                <Col md={6} lg={4}>
                  <FormGroup>
                    <Label for="presentAddressLine1">Address - Line 1 <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      id="presentAddressLine1"
                      name="presentAddressLine1"
                      maxLength={50}
                      value={formik.values.presentAddressLine1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.presentAddressLine1 && !!formik.errors.presentAddressLine1}
                    />
                    {formik.touched.presentAddressLine1 && formik.errors.presentAddressLine1 && (
                      <div className="text-danger">{formik.errors.presentAddressLine1}</div>
                    )}</FormGroup>
                </Col>
                <Col md={6} lg={4}>
                  <FormGroup>
                    <Label for="presentAddressLine2">Address - Line 2</Label>
                    <Input
                      type="text"
                      id="presentAddressLine2"
                      name="presentAddressLine2"
                      maxLength={50}
                      value={formik.values.presentAddressLine2}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    /></FormGroup>
                </Col>
                <Col md={6} lg={4}>
                  <FormGroup>
                    <Label for="presentAddressLine3">Address - Line 3</Label>
                    <Input
                      type="text"
                      id="presentAddressLine3"
                      name="presentAddressLine3"
                      maxLength={50}
                      value={formik.values.presentAddressLine3}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    /></FormGroup>
                </Col>
              </Row>
            </Col>
            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="presentPlace">Place (City/Town) <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  id="presentPlace"
                  name="presentPlace"
                  maxLength={25}
                  value={formik.values.presentPlace}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.presentPlace && !!formik.errors.presentPlace}
                />
                {formik.touched.presentPlace && formik.errors.presentPlace && (
                  <div className="text-danger">{formik.errors.presentPlace}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="presentcountry">Country <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="presentcountry"
                  name="presentcountry"
                  options={(country || []).map(cat => ({ value: cat.country_id.toString(), label: cat.country_name }))}
                  value={formik.values.presentcountry || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("presentcountry", selectedOption)}
                  onBlur={formik.handleBlur}
                  className="hrms-select"
                  classNamePrefix="hrms-select"
                />

                {formik.touched.presentcountry && formik.errors.presentcountry && (
                  <div className="text-danger">{formik.errors.presentcountry}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="presentstate">State/Province <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="presentstate"
                  options={(state || []).map((country) => ({
                    value: country.state_id.toString(),
                    label: country.state_name,
                  }))}
                  value={formik.values.presentstate || null} // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("presentstate", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.presentstate && formik.errors.presentstate ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.presentstate && formik.errors.presentstate && (
                  <div className="text-danger">{formik.errors.presentstate}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="presentpostalCode">Postal Code <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  id="presentpostalCode"
                  name="presentpostalCode"
                  value={formik.values.presentpostalCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.presentpostalCode && !!formik.errors.presentpostalCode}
                  className="hrms-select"
                  classNamePrefix="hrms-select"
                />
                {formik.touched.presentpostalCode && formik.errors.presentpostalCode && (
                  <div className="text-danger">{formik.errors.presentpostalCode}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="presentmobile">Mobile <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  id="presentmobile"
                  name="presentmobile"
                  value={formik.values.presentmobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  maxLength={13}
                  invalid={formik.touched.presentmobile && !!formik.errors.presentmobile}
                />
                {formik.touched.presentmobile && formik.errors.presentmobile && (
                  <div className="text-danger">{formik.errors.presentmobile}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="emergency_contact_person">Emergency Contact Per.</Label>
                <Input
                  type="text"
                  id="emergency_contact_person"
                  name="emergency_contact_person"
                  maxLength={60}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.emergency_contact_person}
                />
                {formik.touched.emergency_contact_person &&
                  formik.errors.emergency_contact_person && (
                    <div className="text-danger">{formik.errors.emergency_contact_person}</div>
                  )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="nationality">Nationality</Label>
                <Input
                  type="text"
                  id="nationality"
                  name="nationality"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nationality}
                />
                {formik.touched.nationality && formik.errors.nationality && (
                  <div className="text-danger">{formik.errors.nationality}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="emergency_contact_no">Emergency Contact No.</Label>
                <Input
                  type="text"
                  id="emergency_contact_no"
                  name="emergency_contact_no"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.emergency_contact_no}
                />
                {formik.touched.emergency_contact_no && formik.errors.emergency_contact_no && (
                  <div className="text-danger">{formik.errors.emergency_contact_no}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="community">Community</Label>
                <Input
                  type="text"
                  id="community"
                  name="community"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.community}
                />
                {formik.touched.community && formik.errors.community && (
                  <div className="text-danger">{formik.errors.community}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="pan_no">PAN No<span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  id="pan_no"
                  name="pan_no"
                  maxLength={10}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.pan_no}
                />
                {formik.touched.pan_no && formik.errors.pan_no && (
                  <div className="text-danger">{formik.errors.pan_no}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="work_email">Work Email <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  id="work_email"
                  name="work_email"
                  maxLength={100}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_email}
                />
                {formik.touched.work_email && formik.errors.work_email && (
                  <div className="text-danger">{formik.errors.work_email}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="aadhar_no">Aadhaar Number <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  maxLength={12}
                  id="aadhar_no"
                  name="aadhar_no"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.aadhar_no}
                />
                {formik.touched.aadhar_no && formik.errors.aadhar_no && (
                  <div className="text-danger">{formik.errors.aadhar_no}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4} className="mb-3">
              <FormGroup>
                <Label for="uan_no">UAN Number <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  id="uan_no"
                  maxLength={12}
                  name="uan_no"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.uan_no}
                />
                {formik.touched.uan_no && formik.errors.uan_no && (
                  <div className="text-danger">{formik.errors.uan_no}</div>
                )}
              </FormGroup>
            </Col>

            <Col className="d-flex  col-12">
              <FormGroup>
                <Label for="sameAsPermanent" className="mb-0 d-flex align-items-center gap-2">
                  <Input
                    type="checkbox"
                    id="sameAsPermanent"
                    checked={formik.values.sameAsPermanent}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      formik.setFieldValue("sameAsPermanent", isChecked);

                      if (isChecked) {
                        // Copy present address values to permanent address
                        formik.setValues({
                          ...formik.values,
                          sameAsPermanent: true,
                          permanentAddressLine1: formik.values.presentAddressLine1,
                          permanentAddressLine2: formik.values.presentAddressLine2,
                          permanentAddressLine3: formik.values.presentAddressLine3,
                          permanentPlace: formik.values.presentPlace,
                          permanentcountry: formik.values.presentcountry,
                          permanentstate: formik.values.presentstate,
                          permanentpostalCode: formik.values.presentpostalCode,
                          permanentmobile: formik.values.presentmobile,
                        });
                      } else {
                        // Reset permanent address fields if unchecked
                        formik.setValues({
                          ...formik.values,
                          sameAsPermanent: false,
                          permanentAddressLine1: "",
                          permanentAddressLine2: "",
                          permanentAddressLine3: "",
                          permanentPlace: "",
                          permanentcountry: "",
                          permanentstate: "",
                          permanentpostalCode: "",
                          permanentmobile: "",
                        });
                      }
                    }}
                    onBlur={formik.handleBlur}
                  />
                  {' '}Same As Permanent Address
                </Label>
              </FormGroup>
            </Col>

            <Col className="col-12 mt-2">
              <h6 className="mb-3">Permanent Address</h6>
              <Row>
                <Col md={6} lg={4}>
                  <FormGroup>
                    <Label for="permanentAddressLine1">Address - Line 1</Label>
                    <Input
                      type="text"
                      id="permanentAddressLine1"
                      name="permanentAddressLine1"
                      value={formik.values.permanentAddressLine1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.permanentAddressLine1 && formik.errors.permanentAddressLine1 && (
                      <div className="text-danger">{formik.errors.permanentAddressLine1}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={6} lg={4}>
                  <FormGroup>
                    <Label for="permanentAddressLine2">Address - Line 2</Label>
                    <Input
                      type="text"
                      id="permanentAddressLine2"
                      name="permanentAddressLine2"
                      value={formik.values.permanentAddressLine2}
                      onChange={formik.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={6} lg={4}>
                  <FormGroup>
                    <Label for="permanentAddressLine3">Address - Line 3</Label>
                    <Input
                      type="text"
                      id="permanentAddressLine3"
                      name="permanentAddressLine3"
                      value={formik.values.permanentAddressLine3}
                      onChange={formik.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="permanentPlace">Place (City/Town)</Label>
                <Input
                  type="text"
                  id="permanentPlace"
                  name="permanentPlace"
                  value={formik.values.permanentPlace}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.permanentPlace && formik.errors.permanentPlace && (
                  <div className="text-danger">{formik.errors.permanentPlace}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="permanentcountry">Country</Label>
                <Select
                  styles={SelectcustomStyles}
                  id="permanentcountry"
                  name="permanentcountry"
                  options={(country || []).map(cat => ({ value: cat.country_id.toString(), label: cat.country_name }))}
                  value={formik.values.permanentcountry || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("permanentcountry", selectedOption)}
                  onBlur={formik.handleBlur}
                  className="hrms-select"
                  classNamePrefix="hrms-select"
                />
                {formik.touched.permanentcountry && formik.errors.permanentcountry && (
                  <div className="text-danger">{formik.errors.permanentcountry}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="permanentstate">State/Province</Label>
                <Select
                  styles={SelectcustomStyles}
                  id="permanentstate"
                  options={(state || []).map((country) => ({
                    value: country.state_id.toString(),
                    label: country.state_name,
                  }))}
                  value={formik.values.permanentstate || null} // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("permanentstate", selectedOption)}
                  onBlur={formik.handleBlur}
                  className="hrms-select"
                  classNamePrefix="hrms-select"
                />
                {formik.touched.permanentstate && formik.errors.permanentstate && (
                  <div className="text-danger">{formik.errors.permanentstate}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="permanentpostalCode">Postal Code</Label>
                <Input
                  type="text"
                  id="permanentpostalCode"
                  name="permanentpostalCode"
                  value={formik.values.permanentpostalCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.permanentpostalCode && formik.errors.permanentpostalCode && (
                  <div className="text-danger">{formik.errors.permanentpostalCode}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={6} lg={4}>
              <FormGroup>
                <Label for="permanentmobile">Mobile</Label>
                <Input
                  type="text"
                  id="permanentmobile"
                  name="permanentmobile"
                  value={formik.values.permanentmobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.permanentmobile && formik.errors.permanentmobile && (
                  <div className="text-danger">{formik.errors.permanentmobile}</div>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Col className="col-12">
            <Row className="d-flex align-items-center">
              {/* <Col md={6} lg={4} className="mb-3">
                <FormGroup check>
                  <Label className="mb-0 d-flex align-items-center gap-2">
                    <Input
                      type="checkbox"
                      id="physicallyChallenged"
                      name="physicallyChallenged"
                      onChange={formik.handleChange}
                      checked={formik.values.physicallyChallenged}
                    />{" "}
                    Physically challenged
                  </Label>
                </FormGroup>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <FormGroup check>
                  <Label className="mb-0 d-flex align-items-center gap-2">
                    <Input
                      type="checkbox"
                      id="timeSheet"
                      name="timeSheet"
                      onChange={formik.handleChange}
                      checked={formik.values.timeSheet}
                    />{" "}
                    Time Sheet
                  </Label>
                </FormGroup>
              </Col> */}
              {/* <Col md={6} lg={4} className="mb-3">
                <FormGroup>
                  <Label for="dataUpdateByEmployee" className="mb-0 d-flex align-items-center">
                    <Input
                      type="checkbox"
                      id="dataUpdateByEmployee"
                      className="me-2" 
                      onChange={formik.handleChange}
                      checked={formik.values.dataUpdateByEmployee}
                    />
                    Data Update by Employee
                  </Label>
                </FormGroup>
              </Col> */}
            </Row>
          </Col>
          <Row>
            {empID == 0 && (
              <OrganizationalDetails empID={empID} formikRef={orgFormikRef} dropdownData={dropdownData} isActive={false} onCategoryChange={(cat) => setSelectedCategory(cat)}/>
            )}
          </Row>
          <Row>
            <Col className="d-flex justify-content-end">
              {/* <Button type="submit" className="btn button-save d-flex align-items-center gap-2">
                  <i className="fas fa-save " /> Save & Continue
                </Button> */}
                 <button
                  type="button"
                  className="btn button-save d-flex align-items-center gap-2"
                  onClick={formik.handleSubmit}
                >
                  <i className="fas fa-save" /> Save & Continue
                </button>
            </Col>
          </Row>

        </CardBody>
      </Card>
    </div >
  );
};

export default EmployeePersonal;
